<template>
    <div class="blog-posts">
        <div v-if="filters.keywords !== null || filters.tag !== null" class="semi-white sticky-top">
            <h3 class="display-5 upper">
                <b>{{view.length}}</b> résultats
            </h3>

            <h3 v-if="filters.tag !== null" class="display-5 upper">
                <b-link class="text-danger mr-1" @click.prevent="$emit('resetTag')">x</b-link>
                Catégorie: <b class="text-blue">{{ filters.tag }}</b>
            </h3>

            <h3 v-if="filters.keywords !== null" class="display-5 upper">
                <b-link class="text-danger mr-1" @click.prevent="$emit('resetKw')">x</b-link>
                Recherche: <b class="text-blue">{{ filters.keywords }}</b>
            </h3>

            <h3 v-if="filters.tag === null && filters.keywords === null" class="display-5 upper py-3 mt-5">
                Autres <span class="text-blue">parutions</span>
            </h3>
        </div>

        <div v-if="view" class="posts">
            <div
                v-for="(post, index) in view" 
                v-bind:key="'post-' + index"
            >
                <b-card 
                    v-if="post.id !== current"
                    class="mb-5"
                >
                    <b-row>
                        <b-col 
                            cols="12" 
                            lg="3"  
                            :style="{
                                backgroundImage: 'url(' + post.img + ')',
                                backgroundSize: 'cover'
                            }"
                            class="post-pic-preview"
                        >
                        </b-col>

                        <b-col 
                            cols="12" 
                            lg="9" 
                        >
                            {{ post.date }}<br>
                            <b v-if="post.title">{{ post.title.toUpperCase() }}</b><br>
                            <p class="text-muted">{{ preview(post.content[0].text) }}...</p>
                            <b-link 
                                v-if="post.title"
                                :to="'/' + post.url"
                                :title="'Consulter l\'article ' + post.title"
                                @click="$emit('postSelected')"
                            >
                                <b-badge 
                                    variant="dark"
                                    class="stretched-link"
                                >Lire l'article</b-badge>
                            </b-link>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: [
      'view',
      'filters',
      'current'

  ],
  methods: {
    buildArticle(content) {
        let built = document.createElement("div")

        for (let i in content) {
            console.log(content[i])
            let block = document.createElement(content[i].type)
            block.innerHTML = content[i].content
            if (content[i].type.includes('h')) block.classList.add("text-blue")
            built.appendChild(block)
        }

        return built.innerHTML
    },
    preview(text) {
        text = text.split(" ", 45)
        return text.join(" ").trim()
    },
    sendMessage() {
      this.$emit('sendMessage')
    }
  }
}
</script>

<style scoped>
.post-pic-preview {
    min-height: 15vh;
    margin-bottom: 2vh;
}

.post-meta {
  z-index: 10;
}

.post-body {
    transition: all 0.5s ease;
    z-index: 10;
}

.post-body.preview {
    max-height: 25vh;
    overflow-y: hidden;
}

.post-wrapper {
    position: relative;
}

.preview-expender {
    position: absolute;
    z-index: 100;
    bottom: 0;
    width: 100%;
    background: rgba(255,255,255,0);
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,255,255,0)), color-stop(0%, rgba(255,255,255,0)), color-stop(30%, rgba(255,255,255,1)), color-stop(100%, rgba(255,255,255,1)));
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    background: -o-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    background: -ms-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 30%, rgba(255,255,255,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=0 );
}

.post-header {
    position: relative;
    border-radius: 0;
    color: #fff;
    min-height: 35vh;
}

.post-header > .content,
.post-header > h1,
.post-header > .lead,
.post-header > .btn-cta {
    position: relative;
    left: 0;
    z-index: 100;
}

.post-header > .content,
.post-header > h1,
.post-header > .lead {
    margin: 0 2rem;
}

.post-header > .overlay {
    position: absolute;
    opacity: 0.3;
    top: 0;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
}

.post {
    background-color: #000;
}

.sticky-top {
  top: 15vh;
}
</style>
